import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import Select from "react-select";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Button } from "react-bootstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import { Tab, Nav, Badge } from "react-bootstrap";
import axios from 'axios';
import LoadingComponent from '../../../layouts/nav/loading';

const TeamPromise = () => {


    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ----------------------- branch --------------------
        man_branch: 0,
        branch_list: 0,
        branch_add: 0,
        branch_edit: 0,
        branch_view: 0,
        branch_delete: 0,
        branch_add_staff: 0,
        branch_add_area: 0,
        branch_add_dpoint: 0,
        branch_asign_manager: 0,
        branch_asign_cug: 0,

        man_dpoint: 0,
        dpoint_list: 0,
        dpoint_edit: 0,
        dpoint_delete: 0,
        dpoint_assign_vehicle: 0,

        // --------------------------- pack -------------------
        pack_man: 0,
        man_product: 0,
        prod_catego: 0,
        product_category_list: 0,
        product_category_add: 0,
        product_category_edit: 0,
        product_category_delete: 0,

        product: 0,
        products_list: 0,
        products_add: 0,
        products_edit: 0,
        products_view: 0,
        products_delete: 0,
        products_item_quantity: 0,

        item_quans: 0,
        item_quantity_list: 0,
        item_quantity_edit: 0,
        item_quantity_view: 0,

        man_pack: 0,
        package_list: 0,
        package_edit: 0,
        package_delete: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list: 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,

        // ------------------------------- subscription ------------------
        subs_man: 0,
        man_subs: 0,
        subscription_list: 0,
        subscription_view: 0,
        subscription_edit: 0,
        subscription_export: 0,
        subscription_hold: 0,
        subscription_complaints: 0,
        subscription_renewal: 0,
        subscription_payment: 0,
        subscription_drop: 0,
        subscription_special_case: 0,

        man_order: 0,
        order_list: 0,
        order_edit: 0,
        order_view: 0,
        order_new_subs: 0,
        order_drop_subs: 0,
        order_convert_subscriber: 0,

        man_drop: 0,
        drop_list: 0,
        drop_export: 0,

        // ----------------------------------- payment ------------------------
        pay_man: 0,
        man_payment: 0,
        payment_export: 0,
        payment_list: 0,

        man_refund: 0,
        refund_list: 0,
        refund_export: 0,
        refund_update: 0,

        // -------------------------- production ----------------------
        prod_man: 0,
        man_items: 0,
        item_catego: 0,
        item_category_list: 0,
        item_category_add: 0,
        item_category_edit: 0,
        item_category_delete: 0,

        item_sub_catego: 0,
        item_sub_category_list: 0,
        item_sub_category_add: 0,
        item_sub_category_edit: 0,
        item_sub_category_delete: 0,

        items: 0,
        items_list: 0,
        items_add: 0,
        items_edit: 0,
        items_view: 0,
        items_delete: 0,
        item_needed_material: 0,
        item_receipe_notes: 0,

        comp_man: 0,
        complaint_list: 0,
        complaint_add: 0,
        complaint_status: 0,
        complaint_view: 0,

        maintenance_man: 0,
        man_vehi: 0,
        vehicle_list: 0,
        vehicle_add: 0,
        vehicle_edit: 0,
        vehicle_view: 0,
        vehicle_delete: 0,
        vehicle_maintannce: 0,
        vehicle_export: 0,

        man_mainten: 0,
        maintenance_list: 0,
        maintenance_edit: 0,
        maintenance_status: 0
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);


    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const tableRef = useRef(null);
    const [key, setKey] = useState('break_box');

    const [datas, setData] = useState([]);
    const [responses, setresp] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [loading, setLoading] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    // page table data fetch
    const fetchData = () => {
        setLoading(true);
        const params = {
            page,
            per_page: perPage,
            search: searchTerm,
            branch_id: branch_id
        };
        axios.get(`${baseURL}/team_management/today_promises`, { params: params })
            .then(response => {
                setData(response.data.data);
                setresp(response.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);


    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };


    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const [isMaintenance, setIsMaintenance] = useState(false);
    // const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "team-promise"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    if (loading) {
        return <div>Loading...</div>; // optional loading state
    }

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Team Promise </strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }


    return (
        <>

            <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Team Promise</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Team Management</li>
                    </ol>
                </div>
            </div>

            <LoadingComponent loading={loading} />

            {permissions.promise_today_list === 1 && (
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="break_box">
                                    <i class="fa-solid fa-calendar-day text-danger me-2"></i>
                                    <label className="fs-6">
                                        Today
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/team-monthly-promise">
                                    <i class="fa-solid fa-calendar-days text-danger me-2"></i>
                                    <label className="fs-6">
                                        Month
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="break_box">
                                <div className='d-flex align-items-center justify-content-end mt-2 gap-3 flex-wrap mb-2'>
                                    <label className='border border-danger fs-6 font-w600 text-danger rounded px-1 py-2'>{responses.date}</label>
                                </div>

                                <div className="table-container mb-4">

                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        {/* Left: Show entries dropdown */}
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                className="form-select d-inline w-auto"
                                                style={{ fontSize: '0.85rem', height: '30px' }}
                                                value={perPage}
                                                onChange={(e) => {
                                                    setPerPage(Number(e.target.value));
                                                    setPage(1); // Reset to first page
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </div>

                                        {/* Right: Search input */}
                                        <div>
                                            <input
                                                type="text"
                                                style={{ fontSize: '0.85rem', height: '40px' }}
                                                placeholder="Search..."
                                                className="form-control"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setPage(1); // Reset page on new search
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <table style={{ borderBottom: '2px solid #ddd' }} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr className="text-start align-middle fw-bold fs-6 gs-0 bg-primary">
                                                <th className="min-w-80px px-2 ">Sales Person</th>
                                                <th className="min-w-50px px-1 text-center">Promise Count</th>
                                                <th className="min-w-50px px-1 text-center">Convert Customer</th>
                                                <th className="min-w-50px px-1 text-center">Date / Time</th>
                                                <th className="min-w-50px px-1 text-center">Reason</th>
                                                <th className="min-w-50px px-1 text-center">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7 align-middle text-start">
                                            {datas.length === 0 && hasFetched ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center text-muted py-2">
                                                        No data available
                                                    </td>
                                                </tr>
                                            ) : (
                                                <>
                                                    {datas.map((data, index) => (
                                                        <tr key={data.sales_person_id}>
                                                            <td>
                                                                <div className="d-flex align-items-center justify-content-start gap-2">
                                                                    <LightGallery
                                                                        onInit={onInit}
                                                                        speed={500}
                                                                        plugins={[lgThumbnail, lgZoom]}
                                                                    >
                                                                        <div data-src={data.profile_image} className='border rounded px-1 py-0'>
                                                                            <img src={data.profile_image} alt={data.name} className='cursor-pointer w-60px h-60px' />
                                                                        </div>
                                                                    </LightGallery>
                                                                    <div>
                                                                        <label className='text-black font-w400 fs-7'>{data.name}</label>
                                                                        <div className="d-flex flex-column">
                                                                            <label className="fs-8 text-dark">{data.phone}</label>
                                                                            <Badge bg="info" className='fw-bold fs-8'>{data.designation} </Badge>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className='text-center'>
                                                                <Badge bg="danger" className='fw-bold fs-7 text-white'>{data.promise_count}</Badge>
                                                            </td>
                                                            <td className='text-center'>
                                                                <Badge bg="success" className='fw-bold fs-7 text-white'>{data.converted_count}</Badge>
                                                            </td>
                                                            <td className='text-center'>
                                                                <label className='fw-bold text-black fs-7'>{data.fomated_date}</label>
                                                                <div className="d-flex flex-column">
                                                                    <label className="fs-8 text-dark">{data.formatted_time}</label>
                                                                </div>
                                                            </td>
                                                            <td className='text-center'>
                                                                <label className='fw-bold text-black fs-7'>{data.reason}</label>
                                                            </td>
                                                            <td className='text-center'>
                                                                <Badge bg={data.status === 1 ? "success" : "danger"} className='fw-bold fs-7 text-white'>{data.status_value}</Badge>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            )}
                                        </tbody>
                                    </table>

                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        {/* Bottom left: Showing x to y of z entries */}
                                        <div>
                                            {datas.length > 0 ? (
                                                <span className="text-muted">
                                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                                </span>
                                            ) : (
                                                <span className="text-muted">
                                                    Showing 0 to 0 of 0 entries
                                                </span>
                                            )}
                                        </div>

                                        {/* Bottom right: Pagination */}

                                        <nav>
                                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                {/* Previous Button */}
                                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                        Previous
                                                    </button>
                                                </li>

                                                {/* First Page */}
                                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                        1
                                                    </button>
                                                </li>

                                                {/* Left Ellipsis */}
                                                {page > 4 && (
                                                    <li className="page-item disabled">
                                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                    </li>
                                                )}

                                                {/* Pages Around Current */}
                                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                    .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                    .map(p => (
                                                        <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                                {p}
                                                            </button>
                                                        </li>
                                                    ))}

                                                {/* Right Ellipsis */}
                                                {page < totalPages - 3 && (
                                                    <li className="page-item disabled">
                                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                    </li>
                                                )}

                                                {/* Last Page */}
                                                {totalPages > 1 && (
                                                    <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                            {totalPages}
                                                        </button>
                                                    </li>
                                                )}

                                                {/* Next Button */}
                                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>

                                <div className='row mb-2 px-2 py-2 mx-2 border border-gray800 rounded'>
                                    <div className='col-11 d-flex p-2 m-auto d-flex flex-wrap flex-lg-nowrap align-items-center justify-content-center'>
                                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                                            <div className='col-12 mb-2'>
                                                <span className='text-black fw-semibold fs-6'>Total Lead</span>
                                            </div>
                                            <div className='col-12 fw-bold fs-4 text-black'>
                                                <span className='fs-5 fw-bold text-primary'>{responses.total_lead}</span>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                                            <div className='col-12 mb-2'>
                                                <span className='text-black fw-semibold fs-6'>Month Lead</span>
                                            </div>
                                            <div className='col-12 fw-bold fs-4 text-black'>
                                                <span className='fs-5 fw-bold text-primary'>{responses.total_month_lead}</span>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                                            <div className='col-12 mb-2'>
                                                <span className='text-black fw-semibold fs-6'>Promise Count</span>
                                            </div>
                                            <div className='col-12 fw-bold fs-4 text-black'>
                                                <span className='fs-5 fw-bold text-primary'>{responses.total_promise_count}</span>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                                            <div className='col-12 mb-2'>
                                                <span className='text-black fw-semibold fs-6'>Convert Customer</span>
                                            </div>
                                            <div className='col-12 fw-bold fs-4 text-black'>
                                                <span className='fs-5 fw-bold text-primary'>{responses.total_converted_count}</span>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                                            <div className='col-12 mb-2'>
                                                <span className='text-black fw-semibold fs-6'>Success Count</span>
                                            </div>
                                            <div className='col-12 fw-bold fs-4 text-black'>
                                                <span className='fs-5 fw-bold text-primary'>{responses.total_success_count}</span>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                                            <div className='col-12 mb-2'>
                                                <span className='text-black fw-semibold fs-6'>Failure Count</span>
                                            </div>
                                            <div className='col-12 fw-bold fs-4 text-black'>
                                                <span className='fs-5 fw-bold text-primary'>{responses.total_failure_count}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            )}

            {permissions.promise_today_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

        </>
    )


}
export default TeamPromise;